import { render, staticRenderFns } from "./AccStatementIcon.vue?vue&type=template&id=2c535b9b&"
import script from "./AccStatementIcon.vue?vue&type=script&lang=js&"
export * from "./AccStatementIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c535b9b')) {
      api.createRecord('2c535b9b', component.options)
    } else {
      api.reload('2c535b9b', component.options)
    }
    module.hot.accept("./AccStatementIcon.vue?vue&type=template&id=2c535b9b&", function () {
      api.rerender('2c535b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/Expenses/AccStatementIcon.vue"
export default component.exports